var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPriceCaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.25 10.5C23.5855 10.5 20.9308 13.2422 18.4983 16.3555C16.0658 13.2422 13.4128 10.5 9.75002 10.5C4.92528 10.5 1.00003 14.4252 1.00003 19.25C0.997226 20.3982 1.22133 21.5357 1.65951 22.597C2.09768 23.6584 2.74128 24.6227 3.55329 25.4345C4.36209 26.25 5.3248 26.8966 6.38556 27.3371C7.44632 27.7776 8.58398 28.0028 9.73252 28H9.75352C13.4093 27.9912 16.0623 25.249 18.4965 22.1357C20.9308 25.2542 23.5855 28 27.25 28C32.0748 28 36 24.0747 36 19.25C36 14.4252 32.0748 10.5 27.25 10.5ZM9.74652 24.5L9.73252 26.25V24.5C8.33427 24.5 7.02002 23.954 6.03302 22.9635C5.30152 22.2278 4.80409 21.2921 4.60334 20.2741C4.4026 19.2561 4.50757 18.2016 4.90497 17.2433C5.3024 16.285 5.97452 15.4656 6.83669 14.8884C7.69887 14.3113 8.71252 14.0022 9.75002 14C12.0775 14 14.23 16.5165 16.3055 19.2465C14.2265 21.9747 12.074 24.4947 9.74652 24.5ZM27.25 24.5C24.9225 24.5 22.7683 21.98 20.6893 19.2465C22.7665 16.5165 24.919 14 27.25 14C30.1445 14 32.5 16.3555 32.5 19.25C32.5 22.1445 30.1445 24.5 27.25 24.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPriceCaps);
export default __webpack_public_path__ + "static/media/no-price-caps.cb0765faeaec227ed4341e41a2ebc22b.svg";
export { ForwardRef as ReactComponent };